import React from "react";
import { Toggle } from "@opendate-app/setlist";

import { hasOptOut, OPT_OUT_TEXT, withOptOut } from "./smsOptOut";

const dividedStyle = {
  borderTop: "1px solid var(--sl-border-secondary)",
  padding: "var(--setlist-spacing-lg) 10px",
};

const hintStyle = { fontSize: 13, color: "var(--sl-text-tertiary)", marginTop: "var(--setlist-spacing-xs)" };

const SmsOptOutToggle = ({ text, onChange, divided = false, style }) => (
  <div style={{ ...(divided ? dividedStyle : {}), ...style }}>
    <Toggle
      label="Add opt-out text"
      checked={hasOptOut(text)}
      onChange={(event) => onChange(withOptOut(text, event.target.checked))}
    />
    <div style={hintStyle}>
      Adds “{OPT_OUT_TEXT}” as the last line. Required the first time you text a fan.
    </div>
  </div>
);

export default SmsOptOutToggle;
